import axios from "axios";

import Navbar from './Navbar'
import Topbar from './Topbar'


import {useState, useEffect} from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {APIURL} from './config'
import Loading from './Loading'

function TarefaUnica() {

    const locate = useLocation()

    const navigate = useNavigate()

    const [myid, setMyid] = useState()
    const [results, setResults] = useState()
    const [messages, setMessages] = useState()
    const [messagescodes, setMessagescodes] = useState()

    const [displaydescarte, setDisplaydescarte] = useState('none')
    const [razao, setRazao] = useState('')
    const [tarefa, setTarefa] = useState('') 
    const [displayanalise, setDisplayanalise] = useState(false)
    const [razaoresultado, setRazaoresultado] = useState('')

    const [listaclassificacao, setListaclassificacao] = useState('')
    const [listatipo, setListatipo] = useState('')
    const [classificacao, setClassificacao] = useState('')
    const [tipo, setTipo] = useState('')

    const [selectedQuestions, setSelectedQuestions] = useState();
    const [myformid, setMyFormId] = useState();

    const [abaAtiva, setAbaAtiva] = useState(); 


    const mytoken = sessionStorage.getItem("tokeninovacao")
    //id da ideia
    const myprocessid = locate.state.processo_id
    const myprocessnumber = locate.state.processo_numero


    let tipomessage
    

    useEffect(() => {
        if (!sessionStorage.getItem("tokeninovacao")) {
            navigate('/login')
        }
        listresume()
    }, [tarefa])

    const listresume= async () => {
        try {
            
            const res1 = await axios.post(`${APIURL}/Process/Tasks`, {TOKEN : mytoken, Id_Process: myprocessid});
            if (res1.data.length > 0) {
                setMyid(res1.data[0].ID)
                const res = await axios.post(`${APIURL}/Process/IdentifyTask`, {TOKEN : mytoken, Id: res1.data[0].ID});
                if (res.data.Type) {
                    setResults(res.data);
                    if (res.data.Type == "Validação") {
                        setAbaAtiva("aba2")
                    }
                    if (res.data.Type == "Análise") {
                        setAbaAtiva("aba3")
                    }
                    setMessages(res.data.Messages)
                    if (messages) {
                        setMessagescodes(Object.keys(messages))
                    }
                }
                //pega as classificações existentes
                const res2 = await axios.post(`${APIURL}/Process/ListProcessClassificationForService`, {TOKEN : mytoken, Id_Service: "5716", Id_Process_Category:"10351"});
                if (res2.data[0].id) {
                    setListaclassificacao(res2.data);
                } else {
                    alert("Erro na seleção de classificação")
                }
                
                //pega o id do form associado a tarefa
                const res4 = await axios.post(`${APIURL}/Inovation/Idea`, {TOKEN : mytoken, Id :myprocessid});
                if (res4.data.Return) {
                    setMyFormId(res4.data.Id_Form)
                } else {
                    alert('Erro em recuperar a ideia!')
                }

                //pega as perguntas para análise
                const res3 = await axios.post(`${APIURL}/Form/IdentifyForm`, {TOKEN : mytoken, Id_Form: res4.data.Id_Form});
                if (res3.data.Return) {
                    const questions = res3.data.Questions;
                    //setSelectedQuestions(questions);
                    
                    // Filtrar os IDs desejados
                    let filtered
                    if (res.data.Type == "Análise") {
                        filtered = questions.filter(q => q.Id >= 20872 && q.Id <=  20878);
                    }
                    setSelectedQuestions(filtered);
                }
            }
           
        } catch (err) {
            alert("Ocorreu um erro. Tente novamente.");
        }
    }  

    const iniciartarefa= async () => {
        
        try {
            const res = await axios.post(`${APIURL}/Process/StartTask`, {TOKEN : mytoken, Id_Task: myid});
            if (res.data.Return) {
                //por enquanto só uso o state abaixo para a pagina ser relida
                listresume()
            } else {
                alert('Erro na abertura da tarefa!')
            }
        } catch (err) {
            alert("Ocorreu um erro na chamada da abertura da tarefa.");
        }
    } 
    
    const formdescartar= async (e) => {
        e.preventDefault()
        if ( displaydescarte == 'none'){
            setDisplaydescarte('flex')
        } else {
            setDisplaydescarte('none')
        }
    } 

    const descartar= async (e) => {
        e.preventDefault()
        if ( !razao) {
            alert('Precisa escolher uma razão para o descarte.')
        } else {
            try {
                const res = await axios.post(`${APIURL}/Process/CancelProcess`, {TOKEN : mytoken, Id: myprocessid, Number: myprocessnumber, Motive: razao});
                if (res.data.Return) {
                    navigate('/tarefas')
                } else {
                    alert('Erro no cancelamento da ideia!')
                }
            } catch (err) {
                alert("Ocorreu um erro na chamada do cancelamento da ideia.");
            }
        }
        
    } 

    const doClassify= async (e) => {
        e.preventDefault()
        if ( !classificacao || !tipo) {
            alert('Precisa escolher a classificação e o tipo!')
        } else {
            try {
                alert(myprocessid)
                alert(classificacao)
                const res = await axios.post(`${APIURL}/Process/ClassifyProcess`, {TOKEN : mytoken, Id: myprocessid, Id_Type : 9026, Id_Classification: classificacao, Id_Type: tipo});
                if (res.data.Return) {
                    listresume()
                } else {
                    alert('Erro na classificação!')
                }
            } catch (err) {
                alert("Ocorreu um erro na chamada.");
            }
        }
        
    } 

    const listartipos= async (classificacao) => {
        alert(classificacao)
        if ( !classificacao ) {
            alert('Precisa escolher a classificação!')
        } else {
            try {
                setClassificacao(classificacao)
                //pega os tipos existentes
                const res3 = await axios.post(`${APIURL}/Process/ListProcessClassificationTypesForService`, {TOKEN : mytoken, Id_Service: "5716", Id_Process_Category: "10351", Id_Classification: classificacao});
                if (res3.data[0].id) {
                    setListatipo(res3.data);
                } else {
                    alert("Erro na listagem de tipos!")
                }
            } catch (err) {
                alert("Ocorreu um erro na chamada.");
            }
        }
        
    } 

    const mostraranalise= async () => {
        if (displayanalise == false) {
          setDisplayanalise(true)
        } else {
          setDisplayanalise(false)
        }
    } 

    const passartarefa = async () => {
        //a ordem das tarefas está no fluxo. Cada tarefa tem uma fase associada. A ordem das fases, dadas por results.Type, é Validação - Análise - Aprovação - Resultados
        alert(results.Type)
        try {
            
            if (results.Type == "Análise") {
                
                //verificar se todas as perguntas tem value_int preenchido
                const res3 = await axios.post(`${APIURL}/Form/IdentifyForm`, {TOKEN : mytoken, Id_Form: myformid});
                if (res3.data.Return) {
                    //alert(results.Type)
                    const todosPreenchidos = res3.data.Questions.every(item => item.Value_Int !== null && item.Value_Int !== undefined && item.Value_Int !== 0);

                    if (!todosPreenchidos) {
                        
                        alert("Há campos não preenchidos na avaliação!");
                        return
                        // talvez mostre uma mensagem de erro ou impeça o envio
                    }
                }

            }
            //vai fechar a tarefa atual, com status Terminado. Vai criar uma nova tarefa, com status em Aberto
            //na ideia não vai mudar nada
             alert(mytoken + " " + myprocessid)
            const res = await axios.post(`${APIURL}/Process/FinishTask`, {TOKEN : mytoken, Id_Task: myid, AnwserFollowingQuestion:true, AnwserValue:true});
           
            if (res.data.Return) {
                listresume()
                //navigate('/tarefaunica', {state: {tarefa_id: myid}})
                //navigate('/tarefaunicaanalise', {state: {tarefa_id: myid}})
            } else {
                alert('Erro na passagem para a próxima fase!')
            }
        } catch (err) {
            alert("Ocorreu um erro na chamada ao passar a tarefa.");
        }
    } 

    const resultado = async (num) => {
        if (razaoresultado == '') {
            alert("Precisa inserir um motivo!")
            return
        }
        try {
            const res = await axios.post(`${APIURL}/Process/ApproveRejectTask`, {TOKEN: mytoken, Id_Task: myid, IsApproved: num, Motive: razaoresultado});
            if (res.data.Return) {
                if (num == 1) {
                    listresume()
                } else {
                    navigate('/tarefas')
                }
                //setTarefa(num)
                //navigate('/tarefaunica', {state: {tarefa_id: myid}})
            } else {
                alert('Erro no resultado!')
            }
        } catch (err) {
            alert("Ocorreu um erro na chamada.");
        }
    } 

    function retornadata(data) {
        let myday
        let mymonth
        let myyear
        if (data && isNaN(new Date(data).getDate())) {
            //não converteu direito
            myday = data.substring(0, 2)
            mymonth = data.substring(3, 5)
            myyear = data.substring(6,10)
        } else {
            myday = new Date(data).getDate()
            mymonth = new Date(data).getMonth()+1
            myyear = new Date(data).getFullYear()
        }
        const mydate = myday + '/' + mymonth + '/' + myyear
        return mydate
    }

    function BarraEtapas(tipo) {
        return(
            <ul class="nav nav-tabs" >
                <li class="nav-item" >
                    <button className={`nav-link ${abaAtiva === "aba1" ? "active" : ""}`} onClick={() => setAbaAtiva("aba1")}>
                        Dados da Ideia
                    </button>
                </li>
                                                
                <li class="nav-item" >
                
                    {tipo == "Validação" ? (
                        <button className={`nav-link ${abaAtiva === "aba2" ? "active" : ""}`} onClick={() => setAbaAtiva("aba2")}>
                            Validação
                        </button>
                    ) : (
                        <button className="nav-link disabled">
                            Validação
                        </button>
                    )}
                </li>
    
                <li class="nav-item" >
                    {tipo == "Análise" ? (
                        
                            <button className={`nav-link ${abaAtiva === "aba3" ? "active" : ""}`} onClick={() => setAbaAtiva("aba3")}>Análise</button>

                    ) : (
                            (tipo == "Aprovação") || (tipo == "Resultados") ? (
                                <button className={`nav-link ${abaAtiva === "aba3" ? "active" : ""}`} onClick={() => setAbaAtiva("aba3")}>Análise</button>
                                // <button  className="nav-link active" onClick={() => mostraranalise()} >Análise </button>
                            ) : (
                                <button className="nav-link disabled">Análise</button>
                            
                            )
                    )}
                </li>
    
                <li class="nav-item" >
                    {tipo == "Aprovação" ? (
  
                        <button className={`nav-link ${abaAtiva === "aba4" ? "active" : ""}`} onClick={() => setAbaAtiva("aba4")}>Aprovação</button>

                        ) : (
                            <button className="nav-link disabled">Aprovação</button>
                        )
                    }
                </li>
               
                 {/* {tipo == "Resultados" ? (
                    <li class="nav-item" role="presentation">
                        <a class="nav-link active" aria-current="page" href="#">Resultados</a>
                    </li>
                ) : (
                    <li class="nav-item"  role="presentation">
                        <a class="nav-link disabled" aria-current="page" href="#">Resultados</a>
                    </li>
                )
                } */}
            </ul>
        )

    }

    const answerquestion = async (numquestion, valor) => {
        
        try {
            const res = await axios.post(`${APIURL}/Form/AnwserFormQuestion`, {TOKEN: mytoken, Id_Form: myformid, Id_Question : numquestion, Value: valor} )
            if (res.data.Return) {
                
                listresume()
            } else {
                alert('Erro em responder a questão!')
            }
        } catch (err) {
            alert("Ocorreu um erro na chamada.");
        }

    }

    function ConteudoDados() {
    return (
        <div className="p-2">
            <table className="table table-striped">
                <tbody>
                    <tr>
                        <td>#</td>
                        <td>{results.Process_Id}</td>
                    </tr>
                    <tr>
                        <td>Título</td>
                        <td>{results.Process_Name}</td>
                    </tr>
                    <tr>
                        <td>Descrição</td>
                        <td>{results.Process_Description}</td>
                    </tr>
                    <tr>
                        <td>Criada em</td>
                        <td>{results.Process_Open_Date}</td>
                    </tr>
                </tbody>
            </table>

        </div>
    );
    }

    function Comentarios() {
        if (messages) {
            messagescodes = Object.keys(messages)
            
        }
                                                  

        messagescodes.map((subitem, i) => {
             tipomessage = messages[subitem].Type
             alert(tipomessage)
             if (tipomessage == "Inovação - Análise Ideia") {
                 return (
                     <div  key={i}>
                         <div className="row " style={{ marginBottom: 20}}>
                             <div className="col-xs-1 center-block">
                                 <i className="fa fa-user-circle-o fa-3x center-block" style={{color:'#1ab394', margin: "auto"}}></i>
                             </div>
                             <div className="col-xs-11 text-left">
                                 <strong>{messages[subitem].User}</strong>
                                 <p>{messages[subitem].Description}</p>
                                 <small >{retornadata(messages[subitem].Creation_Date)}</small>
                                 
                             </div>
                         </div>
                         <div className="row border-bottom" style={{ marginBottom: 20}}>
                         </div>
                     </div>
                 )
             }
         })
    }

    return (

       <div>
            <Topbar />
            {(results && selectedQuestions) ?
                <div className="container py-4 px-2 px-md-5">
                    <div className="">
                        <div className="h4 mb-0">Tarefa #{myid}</div>
                        <div className="small mb-3">{results.Process_Name}</div>
                        <div className="bg-white p-3 mt-4 shadow-sm " >
                               
                            {results.Type == "Validação" &&
                                    <div>
                                        {BarraEtapas("Validação")}
                                        <div className="tab-content mt-3" >
                                            <div className={`tab-pane fade ${abaAtiva === "aba1" ? "show active" : ""}`}   id="aba1">
                                                <p>{ConteudoDados()}</p>
                                            </div>

                                            <div className={`tab-pane fade ${abaAtiva === "aba2" ? "show active" : ""}`} id="aba2">

                                            {results.Status == "em Aberto" &&
                                                <div>
                                                    <div className="m-5 d-flex flex-column align-items-center bg-light p-5 shadow-sm" >
                                                        <button onClick={() => iniciartarefa()} className="btn btn-md  btn-success" >Iniciar Validação </button>
                                                    </div>
                                                </div>
                                            }
                                            {(results.Status == "em Andamento" ) &&
                                                <div>
                                                    <div className="" >
                                                        {displaydescarte == 'none' &&
                                                            <div className="m-5 d-flex flex-column align-items-center bg-light p-5 shadow-sm">
                                                                <p>Clique nos botões abaixo para descartar a ideia ou passar para a próxima etapa.</p>
                                                            
                                                                <div className="d-flex flex-row justify-content-end gap-2">
                                                                    <button onClick={(e)=> formdescartar(e)} className="btn btn-md btn-outline-secondary btn-succcess " >Descartar </button>
                                                                    <button onClick={()=> passartarefa()} className="btn btn-md  btn-success" >Continuar </button>
                                                                </div>
                                                            </div>
                                                        }
                                                        <div className="p-5" style={{display: displaydescarte}}>
                                                            <form onSubmit={(e)=> descartar(e)}  role="form" >
                                                                <p className="fw-bold">Razão para o descarte da ideia:</p>
                                                                <div className="form-group">
                                                                    <p><input onChange={(e)=>setRazao(e.target.value)} type='radio'  name="razaodescarte" value="Sem recursos"></input>  Sem recursos</p>
                                                                </div>
                                                                <div className="form-group">
                                                                    <p><input  onChange={(e)=>setRazao(e.target.value)} type='radio'  name="razaodescarte" value="Já foi feito"></input>  Já foi feito</p>
                                                                </div>
                                                                <div className="form-group">
                                                                    <p><input  onChange={(e)=>setRazao(e.target.value)} type='radio'  name="razaodescarte" value="Já há ideia similar"></input>  Já há ideia similar</p>
                                                                </div>
                                                                <div className="form-group">
                                                                    <p><input  onChange={(e)=>setRazao(e.target.value)} type='radio'  name="razaodescarte" value="Não foi considerado como ideia"></input>  Não foi considerado como ideia</p>
                                                                </div>
                                                                <div className="d-flex justify-content-start mt-5">
                                                                    <button onClick={(e)=> formdescartar(e)}  className="btn btn-md btn-outline-secondary" style={{marginRight: 20}}>Cancelar Descarte</button>
                                                                    <button onClick={(e)=> descartar(e)} className="btn btn-md btn-success ">Descartar Ideia</button>
                                                                    
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                
                                                </div>
                                            }
                                            </div>
                                        </div>
                                    </div>
                            }

                            {(results.Type == "Análise" || results.Type == "Aprovação") &&
                                <div  >
                                    {BarraEtapas(results.Type)}
                                    <div className="tab-content mt-3" >
                                        <div className={`tab-pane fade ${abaAtiva === "aba1" ? "show active" : ""}`}   id="aba1">
                                            <p>{ConteudoDados()}</p>
                                        </div>

                                        <div className={`tab-pane p-3 fade ${abaAtiva === "aba3" ? "show active" : ""}`} id="aba3">
                                            {results.Status == "em Andamento" &&
                                            <div className="">
                                                <div className="row bg-light p-3 mb-3">
                                                    <p className="fw-bold" >Classificação</p>
                                                
                                                    <div class=" " >
                                                        <form onSubmit={(e)=> doClassify(e)} role="form" >
                                                        <div style={{display: 'flex'}}>
                                                            <div className="form-group col-12 col-md-3 " style={{marginRight:20,display: 'flex',  alignItems: "center"}}>
                                                                <label style={{marginRight:20}}>Classificação: </label> 
                                                                <select  onChange={(e)=> listartipos(e.target.value)} className="form-control">
                                                                    <option value="">Selecione...</option>
                                                                    {listaclassificacao &&  listaclassificacao.map((item, i) => {
                                                                        return(
                                                                            <option key={i} value={item.id}>{item.value}</option>
                                                                        )
                                                                    })}
                                                                </select>
                                                            </div>
                                                            <div className="form-group col-12 col-md-3 " style={{marginRight:20,display: 'flex',  alignItems: "center"}}>
                                                                <label style={{marginRight:20}}>Tipo: </label> 
                                                                <select  onChange={(e)=> setTipo(e.target.value)} className="form-control">
                                                                    {classificacao &&
                                                                        <option value="">Selecione...</option>
                                                                    }
                                                                    {listatipo &&  listatipo.map((item, i) => {
                                                                        return(
                                                                            <option key={i} value={item.id}>{item.value}</option>
                                                                        )
                                                                    })}
                                                                </select>
                                                            </div>
                                                            <div className="form-group col-12 col-md-3 " style={{ marginRight:20,display: 'flex',  alignItems: "center", }}>
                                                                <button className=" btn btn-sm btn-success" type="submit">Classificar</button>
                                                            </div>
                                                            
                                                        </div> 
                                                        </form>
                                                    </div>
                                                </div>

                                                <div className="mt-3 row bg-light p-3">
                                                    <p className="fw-bold" >Avaliação</p>
                                                    <div className="col-12">
                                                        {selectedQuestions && selectedQuestions.map((item, i) => {
                                                            return(
                                                            <div key={item.Id} className="row">
                                                                <div className="col-12 col-md-3 mb-3">{item.Alias}</div>
                                                                {/* <td >{item.Value_Int}</td>
                                                                <td >{item.Value}</td> */}
                                                            
                                                                <div className="col-12 col-md-9 mb-3">
                                                                <select  onChange={(e)=> answerquestion(item.Id, e.target.value)} className= "form-control">
                                                                    
                                                                    {item.Type == 98 &&  item.Value_Int && (
                                                                        <option value={item.Value_Int}>{item.Value}</option>
                                                                    )}
                                                                
                                                                    {item.Values.map((subitem, j) => {
                                                                        return(
                                                                            <option key={j} value={subitem.Id}>{subitem.Value}</option>
                                                                        )
                                                                    })}
                                                                </select> 
                                                                </div>
                                                            </div>
                                                            )
                                                        })}

                                                    </div>
                                                </div>

                                                
                                                            

                                                <div className="mt-3 d-flex justify-content-between">
                                                    <div className="">
                                                        <p className="fw-bold" >Comentários</p>
                                                    </div>
                                                    <div className="">
                                                        <Link to="/novocomentarioanalise" state={{tarefa_id: myid, ideia_id: myprocessid, titulo: results.Process_Name}}><button className="btn btn-sm btn-success" type="submit">Novo Comentário</button></Link>
                                                    </div>
                                                </div>
                                                <div className="bg-light" style={{marginTop:10}}>
                                                    {messagescodes && messagescodes.map((subitem, i) => {
                                                        tipomessage = messages[subitem].Type
                                                        if (tipomessage == "Análise Inovação") {
                                                            return (
                                                                <div  key={i}>
                                                                    <div className="row " style={{ marginBottom: 20}}>
                                                                        <div className="col-xs-1 center-block">
                                                                            <i className="fa fa-user-circle-o fa-3x center-block" style={{color:'#1ab394', margin: "auto"}}></i>
                                                                        </div>
                                                                        <div className="col-xs-11 text-left">
                                                                            <strong>{messages[subitem].User}</strong>
                                                                            <p>{messages[subitem].Description}</p>
                                                                            <small >{retornadata(messages[subitem].Creation_Date)}</small>
                                                                            
                                                                        </div>
                                                                    </div>
                                                                    <div className="row border-bottom" style={{ marginBottom: 20}}>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    })}

                                                </div>

                                                <div className="mt-3">
                                                    <p className="fw-bold" >Anexos</p>
                                                </div>

                                                {(results.Type == "Análise" ||  results.Type== "Aprovação") &&
                                                    <div style={{ display: 'flex',  alignItems: 'baseline', justifyContent:'end'}}>
                                                        <button onClick={()=> passartarefa()} className="btn btn-md  btn-success">Continuar </button>
                                                    </div>
                                                }
                                            </div>
                                            }
                                            {results.Status == "em Aberto" &&
                                                <div className="m-5 d-flex flex-column align-items-center bg-light p-5 shadow-sm" >
                                                    <button onClick={() => iniciartarefa()} className="btn btn-md  btn-success" >Iniciar Análise </button>
                                                </div>
                                            }
                                        </div>

                                        {results.Type == "Aprovação" &&
                                            <div className={`tab-pane fade ${abaAtiva === "aba4" ? "show active" : ""}`} id="aba4">
                                                {results.Status == "em Aberto" &&
                                                    <div className="m-5 d-flex flex-column align-items-center bg-light p-5 shadow-sm" >
                                                        <button onClick={() => iniciartarefa()} className="btn btn-md  btn-success" >Iniciar Aprovação </button>
                                                    </div>
                                                    
                                            
                                                }
                                                {(results.Status == "em Andamento" && displaydescarte == 'none') &&
                                                    <div className="p-5" >
                                                        <div  >
                                                            <div >
                                                                <p className="fw-bold">Razão para a aprovação/reprovação:</p>
                                                                <div className="form-group">
                                                                    <textarea onChange={(e)=>setRazaoresultado(e.target.value)} rows="5"  cols="100" className="p-3"></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex justify-content-start mt-3 gap-2">
                                                            
                                                            <button onClick={()=> resultado(0)} className="btn btn-md btn-outline-secondary " >Reprovar </button>
                                                            <button onClick={()=> resultado(1)} className="btn btn-md  btn-success" >Aprovar </button>
                                                        </div>
                                                    </div>
                                                }

                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                      
                        </div>
                    </div>
                </div>
            :
                <Loading />
            }
        </div>
      );
    }
    
    export default TarefaUnica;
